export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-play-ca4b001085fcdfe187f72815a04f5041.svg";